export const TAVOLATA_PERMISSIONS = {
  ACCESS: 'restaurant:terminal:ver',
  SALON: 'restaurant:salon:ver',
  ANFITRION: 'restaurant:anfitrion:operar',
  PEDIDOS: 'restaurant:pedidos:gestionar',
  COCINA: 'restaurant:cocina:ver',
  CAJA: 'restaurant:caja:operar',
};

export const TAVOLATA_ROUTES = {
  SALON: '/salon',
  ANFITRION: '/anfitrion',
  MESERO: '/mesero',
  COCINA: '/cocina',
  CAJA: '/caja',
};

export function permissionSet(tenant) {
  return new Set(Array.isArray(tenant?.permissions) ? tenant.permissions : []);
}

export function buildTavolataAccess(tenant) {
  const permissions = permissionSet(tenant);
  const specific = [
    TAVOLATA_PERMISSIONS.SALON,
    TAVOLATA_PERMISSIONS.ANFITRION,
    TAVOLATA_PERMISSIONS.PEDIDOS,
    TAVOLATA_PERMISSIONS.COCINA,
    TAVOLATA_PERMISSIONS.CAJA,
  ];
  const hasSpecific = specific.some((permission) => permissions.has(permission));
  const legacyFullAccess = permissions.has(TAVOLATA_PERMISSIONS.ACCESS) && !hasSpecific;

  const access = {
    app: permissions.has(TAVOLATA_PERMISSIONS.ACCESS) || hasSpecific,
    salon: legacyFullAccess || permissions.has(TAVOLATA_PERMISSIONS.SALON),
    anfitrion: legacyFullAccess || permissions.has(TAVOLATA_PERMISSIONS.ANFITRION),
    mesero: legacyFullAccess || permissions.has(TAVOLATA_PERMISSIONS.PEDIDOS),
    pedidos: legacyFullAccess || permissions.has(TAVOLATA_PERMISSIONS.PEDIDOS),
    cocina: legacyFullAccess || permissions.has(TAVOLATA_PERMISSIONS.COCINA),
    caja: legacyFullAccess || permissions.has(TAVOLATA_PERMISSIONS.CAJA),
    legacyFullAccess,
  };

  access.defaultPath = access.salon
    ? TAVOLATA_ROUTES.SALON
    : access.anfitrion
      ? TAVOLATA_ROUTES.ANFITRION
      : access.mesero
        ? TAVOLATA_ROUTES.MESERO
        : access.cocina
          ? TAVOLATA_ROUTES.COCINA
          : access.caja
            ? TAVOLATA_ROUTES.CAJA
            : '/';

  // Compatibilidad con la versión anterior del Shell.
  access.defaultView = access.defaultPath.replace('/', '') || null;
  return access;
}
